__turbopack_context__.v({
  "input": "Switch-module-scss-module__3AToHW__input",
  "label": "Switch-module-scss-module__3AToHW__label",
  "shape": "Switch-module-scss-module__3AToHW__shape",
});
